
// src/Database/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, setLogLevel } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCi66qjRQsNrIwhf7RMt5fA1bzSp5vPaSY",
  authDomain: "encraft-org.firebaseapp.com",
  projectId: "encraft-org",
  storageBucket: "encraft-org.firebasestorage.app",
  messagingSenderId: "1000650107359",
  appId: "1:1000650107359:web:8a0b2ae821e4397efc7c6a",
  measurementId: "G-X335ZFGR24"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// ✅ เปิด debug log
setLogLevel("debug");

// Export services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });